import { render, staticRenderFns } from "./Default-Address-Card.vue?vue&type=template&id=0271c88c&"
import script from "./Default-Address-Card.vue?vue&type=script&lang=js&"
export * from "./Default-Address-Card.vue?vue&type=script&lang=js&"
import style0 from "./Default-Address-Card.vue?vue&type=style&index=0&id=0271c88c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports